import { atomWithStorage } from 'jotai/utils';

export const $sidebarCollapsed = atomWithStorage<boolean>(
  'sidebar-collapsed',
  false,
);

export const $expandedModules = atomWithStorage<string[]>(
  'sidebar-expanded-modules',
  [],
);

export const $sidebarWidth = atomWithStorage<number | null>(
  'sidebar-width',
  null,
);
